<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card :header="headerTitle" >
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="proveedores" 
              :fields="itemFields"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(inactivo)="data">
              {{ data.item.inactivo ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Impuesto</b-dropdown-item>
                <!-- <b-dropdown-item @click.stop="inactivar(data.item)">
                  <i class="fa fa-remove"></i>Inactivar Impuesto</b-dropdown-item> -->
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Agregar Nuevo Impuesto</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>

  </div>
</template>

<script>
import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'proveedores/getField',
  mutationType: 'proveedores/updateField',
});

export default {
  name: 'Impuestos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
    // exportPDFReciboCliente
  ],
  data: () => {
    return {
      impuestoOrganismoId: 0,
      impuestoOrganismo: null,
      impuestoOrganismoNombre: null,

      itemFields: [
        {
          key: 'nombreComercial',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'inactivo',
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'proveedores',
      'nombre',
      'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
    headerTitle() {
      // if (this.impuestoOrganismo) {
      //   if (this.impuestoOrganismo.nombre) {
      //     return `Listado de Impuestos - ${this.impuestoOrganismo.nombre.trim()}`;
      //   }
      // }
      if (this.impuestoOrganismoNombre) {
        return `Listado de Impuestos - ${this.impuestoOrganismoNombre.trim()}`;
      }
     
      return `Listado de Impuestos`;
    }
  },
  created() {
    this.impuestoOrganismoId= this.$route.params.impuestoOrganismoId

    this.getDatosAdicionales();

    this.getItems()
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      let params = {
        impuestos: true,
        impuestoOrganismoId: this.impuestoOrganismoId
      }
      
      this.tableBusy = true;
      this.$store.dispatch('proveedores/getProveedores', params)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    getDatosAdicionales() {
      let vm = this;

      this.$store.dispatch('impuestoOrganismo/getDatos', this.impuestoOrganismoId)
        .then(() => {
          vm.impuestoOrganismoNombre = this.$store.getters['impuestoOrganismo/nombre'];
        })
        .catch(error => this.showErrorMsj(error));
    },
    consultar (item) {
      this.$router.push({ name: 'ImpuestoDatos', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'ImpuestoABM', 
                          params: { impuestoOrganismoId: this.impuestoOrganismoId,
                                    id: 0 }});
    },
    editar (item) {
      this.$router.push({ name: 'ImpuestoABM', 
                          params: { impuestoOrganismoId: this.impuestoOrganismoId,
                                    id: item.id }});
    },
    // inactivar (item) {
    //   this.showModalConfirm('¿Desea inactivar el impuesto seleccionado?', 
    //         this.inactivar.bind(this, item.id), 'Si', null, 'No')
    // },
    // inactivarItem (impuestoId) {
    //   this.showSpinner();
    //   this.$store.dispatch('proveedores/inactivar', impuestoId)
    //     .then(() => this.showModalMsj('El impuesto se inactivó con éxito', this.getItems, this.getItems, 'light'))
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner());
    // },    
    goBack() {
      this.$router.push({ name: 'ImpuestosOrganismos' });
      // this.$router.go(-1);
    },    
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
/*
  .card-body >>> table > tbody > tr > td {
    cursor: pointer;
  }
  #btn-filtro {
    position: absolute;
    top: 10px;
    left: calc(100% - 60px);
  }
*/
</style>
